var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlockCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m975 450h-75v-75c0-165.68-134.32-300-300-300s-300 134.32-300 300v75h-75c-41.398 0-75 33.602-75 75v525c0 41.398 33.602 75 75 75h750c41.398 0 75-33.602 75-75v-525c0-41.398-33.602-75-75-75zm-562.5-75c0-103.43 84.148-187.5 187.5-187.5 103.43 0 187.5 84.074 187.5 187.5v75h-375zm112.5 637.5-189.75-189.75 79.5-79.574 110.25 110.25 260.25-260.25 79.5 79.574z",
    fill: "#01447a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockCheck);
export default __webpack_public_path__ + "static/media/padlock-check.9b8b04c9dfdc32cb90a0b6cf0867ab86.svg";
export { ForwardRef as ReactComponent };